import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/special/akinfeev/app/layouts/default.vue").then(m => m.default || m))
}